import { ServiceFetch } from '../service-fetch'

export default class UserLocationModel extends ServiceFetch {
    generateUserLocationLastCode = (data) => this.authFetch({
        url: 'user-location/generateUserLocationLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getUserLocationBy = (data) => this.authFetch({
        url: 'user-location/getUserLocationBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getUserLocationByCode = (data) => this.authFetch({
        url: 'user-location/getUserLocationByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateUserLocationBy = (data) => this.authFetch({
        url: 'user-location/updateUserLocationBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertUserLocation = (data) => this.authFetch({
        url: 'user-location/insertUserLocation',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteUserLocationByCode = (data) => this.authFetch({
        url: 'user-location/deleteUserLocationByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}